import Link from "next/link";
import { Tabs } from "ui";
import { useCarriedQueryParams } from "./utils";

export function FlowsNavigationTabs({
  activeTab,
}: {
  activeTab: "flows" | "valueLists";
}) {
  const query = useCarriedQueryParams();
  return (
    <Tabs value={activeTab}>
      <Tabs.List>
        <Tabs.Tab
          value="flows"
          nativeButton={false}
          render={<Link href={{ pathname: "/flows", query }} />}
        >
          All Flows
        </Tabs.Tab>
        <Tabs.Tab
          value="valueLists"
          nativeButton={false}
          render={<Link href={{ pathname: "/value-lists", query }} />}
        >
          Value Lists
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
